import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../urunDiv.css';
import alfredo from '../../assets/menu/yemekler/makarnalar/alfredo.jpeg';
import pastaItaliano from '../../assets/menu/yemekler/makarnalar/pasta-italiano.jpeg';
import pesto from '../../assets/menu/yemekler/makarnalar/pesto.jpeg';
import chickenMushroom from '../../assets/menu/yemekler/makarnalar/chicken-mushroom.jpeg';
import arabiatta from '../../assets/menu/ana-yemek-2.png';

const Makarnalar = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const makarnalar = [
    { id: 2, name: 'Alfredo', price: '₺479,90', image: alfredo },
    { id: 3, name: 'Pasta İtaliano', price: '₺499,90', image: pastaItaliano },
    { id: 4, name: 'Pesto', price: '₺479,90', image: pesto },
    { id: 5, name: 'Chicken Mushroom', price: '₺529,90', image: chickenMushroom },
    { id: 6, name: 'Arabiatta', price: '₺479,90', image: arabiatta },
  ];

  const handleClick = (item) => {
    if (item.name === 'Alfredo') navigate('/makarnalar/alfredo');
    else if (item.name === 'Pasta İtaliano') navigate('/makarnalar/pasta-italiano');
    else if (item.name === 'Pesto') navigate('/makarnalar/pesto');
    else if (item.name === 'Chicken Mushroom') navigate('/makarnalar/chicken-mushroom');
    else if (item.name === 'Arabiatta') navigate('/makarnalar/arabiatta');
  };

  return (
    isPhone ? (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Makarnalar</h2>
        </div>
        <hr style={{color: '#D8D8D8'}} />
        <div className="urun-grid">
          {makarnalar.map((item) => (
            <div key={item.id} className="urun-kart" onClick={() => handleClick(item)} style={{ cursor: 'pointer' }}>
              <div className="urun-bilgi">
                <h3 className="urun-ad">{item.name}</h3>
                {item.price && <div className="urun-fiyat">{item.price}</div>}
              </div>
              <div className="urun-resim">
                <img src={item.image} alt={item.name} style={{
                  width: '80px',
                  height: '80px',
                  objectFit: 'cover',
                  borderRadius: '100px',
                }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    ) : (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Makarnalar</h2>
        </div>
        <hr style={{color: '#D8D8D8'}} />
        <div className="urun-grid-computer">
          {makarnalar.map((item) => (
            <div key={item.id} className="urun-kart-computer" onClick={() => handleClick(item)} style={{ cursor: 'pointer' }}>
              <div className="urun-bilgi">
                <h3 className="urun-ad-computer">{item.name}</h3>
                {item.price && <div className="urun-fiyat-computer">{item.price}</div>}
              </div>
              <div className="urun-resim">
                <img src={item.image} alt={item.name} style={{
                  width: '100px',
                  height: '100px',
                  objectFit: 'cover',
                  borderRadius: '100px',
                }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default Makarnalar;
